<template>
	<div class="customerLinkWrap">

		<div v-if="getStatuses(line).length" class="statusWrap" >
			<div class="statusItem"
			     v-for="status in getStatuses(line)"
			     :key="status.key"
			>
				<tool-tip
						:text="status.text"
						content-class="top"
						:position="{ top: 'top' }"
				>
					    <span
							    class="status_color"
							    :style="{ background: status.color }"
					    ></span>
				</tool-tip>
			</div>
		</div>

		<span
				v-if="hasCustomerPermission && !item.hideCustomerLink"
				class="linkClassic"
				@click="onClick('link')"
		>
			{{ line[item.value] }}
		</span>
		<span v-else>
			{{ line[item.value] }}
		</span>

		<span class="information"
				v-if="line['information']" 
				@click="onClick('info')"
		>
	    <svg-sprite width="20" height="20" icon-id="attention"></svg-sprite>
	  </span>

	</div>
</template>

<script>
import ToolTip from "@/shared/ToolTip/ToolTip.vue";
import { mapGetters } from "vuex";
import { getPermissionsMod } from "@/helper/getPermissionsMod";
import { PERMISSIONS } from "@/constants/constants";

export default {
	name: "CustomerLink",
	components: { ToolTip },

	props: {
		item: Object,
		line: Object,
	},

	data: () => ({
		statusConfig: {
			frozen: { text: 'Frozen', color: '#e91e63' },
			daptor: { text: 'Debtor', color: '#F49741' },
		},
	}),

	computed: {
		...mapGetters([ 'permissionsDefault' ]),

		hasCustomerPermission() {
			const list = this.permissionsDefault;
			const path = [ PERMISSIONS.MAINTENANCE, PERMISSIONS.CUSTOMERS ];

			return getPermissionsMod({ list, path });
		},
	},

	methods: {
		getStatuses(line) {
			return Object.keys(this.statusConfig)
				.filter(key => line && line[key])
				.map(key => ({
					key,
					text: this.statusConfig[key].text,
					color: this.statusConfig[key].color,
				}));
		},

		onClick(flag) {
			this.$emit('updateModEvent', { flag, line: this.line, item: this.item });
		},
	},
};
</script>

<style scoped lang="scss">

.customerLinkWrap {
	display: flex;
	justify-content: flex-start;
	align-items: center;
	width: 100%;

	.statusWrap {
		display: flex;
		align-items: center;
		gap: 4px;
		margin-right: 10px;
		.statusItem {
			.status_color {
				flex: 0 0 4px;
				width: 4px;
				height: 16px;
				display: inline-block;
			}
		}
	}

	.linkClassic {
		flex-grow: 2;
		color: var(--base-orange);
	}

	.information {
		cursor: pointer;
		color: var(--base-yellow);
		transition: .3s;
		&:hover {
			color: var(--base-green);
		}
		svg {
			display: block;
		}
	}
}
</style>
